import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import Button from '@Components/Button';
import { TooltipConstants } from '@Components/Tooltip';
import { ProjectStatus, ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import HoverTooltip from '@Components/HoverTooltip';

function StatusFlagged({ type, status, tooltipContent, onClick, label }) {
  const formattedStatus = kebabCase(status);

  return (
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip={tooltipContent} place="left">
      <Button
        buttonConfig={{
          type: 'link',
          size: 'md',
          className: 'project-status-grid-item__flagged-button',
          e2eName: `${formattedStatus}-${type}`,
          ariaLabel: 'Flagged',
          label,
          labelWrapperClassName: 'project-status-grid-item__flagged-button-label',
        }}
        iconConfig={{
          position: 'before',
          name: 'flag',
        }}
        onClick={onClick}
      />
    </HoverTooltip>
  );
}

StatusFlagged.defaultProps = {
  onClick: () => null,
  label: 'Click here\nfor options',
};

StatusFlagged.propTypes = {
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
  status: PropTypes.oneOf(ProjectStatus.allTypes),
  tooltipContent: PropTypes.node,
  onClick: PropTypes.func,
  label: PropTypes.string,
};

export default StatusFlagged;
